import { render, staticRenderFns } from "./CotStrutturaEditPage.vue?vue&type=template&id=94d04cfc"
import script from "./CotStrutturaEditPage.vue?vue&type=script&lang=js"
export * from "./CotStrutturaEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports